import React from "react";
import ProbersTable from "./ProbersTable";
import "../styles/components/totaltime-chart.scss";

const ProbersChart = props => {
  const sumAndMax = avgTime(props.data, props.protoType);
  return (
    <div className="total-time">
      <div className="numbers-probers-chart">
        {/* <strong>{sumAndMax.avg}</strong> */}
        {props.protoType !== "HTTP(S)" ? (
          <span className="legend">
            <p>Total time:</p>
            <i className="server">Response time</i>
          </span>
        ) : (
          <span className="legend">
            <p>Total time:</p>
            <i className="connect">Connection</i> +&nbsp;
            <i className="handshake">TLS handshake</i> +&nbsp;
            <i className="server">Response time</i>
          </span>
        )}
      </div>
      <div className="history-probers-chart">
        <ProbersTable
          max={sumAndMax.max}
          data={props.data}
          protoType={props.protoType}
        />
      </div>
    </div>
  );
};

const avgTime = (probers, protoType) => {
  let max = 0;
  if (probers) {
    const sumOfTimes = probers.reduce((acc, curr) => {
      let sumOfCurr = 0;
      if (protoType !== "HTTP(S)") {
        sumOfCurr = curr.timing.duration;
      } else {
        sumOfCurr =
          curr.timing.resolve +
          curr.timing.connect +
          curr.timing.tls +
          curr.timing.response;
      }
      if (max < sumOfCurr) {
        max = sumOfCurr;
      }
      return acc + sumOfCurr;
    }, 0);
    // the 300 added to max is to consider the avg and failed datas width
    return { avg: format(sumOfTimes / probers.length), max: max * 1.15 };
  }
  return { avg: null, max: null };
};

const format = data => {
  if (data < 1000) {
    return `${data == null ? 0 : data.toFixed(2)} ms`;
  } else if (data > 1000) {
    return `${(data / 1000).toFixed(2)} s`;
  }
};

export default ProbersChart;
